export const TOOLBAR = 'toolbar/'
export const TRADUZIONI = 'traduzioni/'
export const REDIRECTS = 'redirects/'
export const CHECK_REVALIDATE = 'check-revalidate/'
